import { Id } from 'src/types'

interface InitialValuesProps {
  description: string
  end_date: string
  fare_value: number
  partner_hotel_room_id: Id
  pension: boolean
  start_date: string
  tax_value: number
  active: boolean
}

export const initialValues = {
  active: false,
  description: '',
  end_date: null,
  fare_value: 0,
  partner_hotel_room_id: 'new',
  pension: false,
  start_date: null,
  tax_value: 0
} as InitialValuesProps
